<template>
  <section class="category">
    <div class="category-container">
      <h1 class="title">
        <span>our categories</span>
        <a class="text-decoration-none" href=""> view all >></a>
      </h1>
      <div class="box-container">
        <div v-for="category in categories" :key="category.id" class="box">
          <router-link to="" class="text-decoration-none">
            <img :src="category.image" alt="" />
            <h3>{{ category.name }}</h3>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const dummyData = {
  categories: [
    {
      id: "1",
      name: "house sofa",
      image: require("@/images/icon-1.png"),
    },
    {
      id: "2",
      name: "working table",
      image: require("@/images/icon-2.png"),
    },
    {
      id: "3",
      name: "corner table",
      image: require("@/images/icon-3.png"),
    },
    {
      id: "4",
      name: "office chair",
      image: require("@/images/icon-4.png"),
    },
    {
      id: "5",
      name: "new wardrobe",
      image: require("@/images/icon-5.png"),
    },
  ],
};

export default {
  data() {
    return {
      categories: [],
    };
  },
  created() {
    this.fetchCategories();
  },
  methods: {
    fetchCategories() {
      this.categories = dummyData.categories;
    },
  },
};
</script>